import React from "react";
import { Checkbox, FormControlLabel, ThemeProvider, createTheme } from "@mui/material";
import colors from "../../themes/colors";

type TableToolbarCheckboxProps = {
  label?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
};

const TableToolbarCheckbox = ({ label, checked, onChange = () => { } }: TableToolbarCheckboxProps) => {

  const theme = createTheme({
    components: {
      MuiCheckbox: {
        styleOverrides: {
          root: {
            padding: "4px",
            position: "relative",
            zIndex: 0,
            "&.Mui-checked:after": {
              content: '""',
              left: 8,
              top: 8,
              height: 15,
              width: 15,
              position: "absolute",
              backgroundColor: "#FAFAFA",
              zIndex: -1
            }
          },
          colorPrimary: {
            color: "#C7C9CD"
          }
        }
      },
      MuiFormControlLabel: {
        styleOverrides: {
          label: {
            color: colors.secondary.gray80,
            fontSize: 14,
            lineHeight: 1.2,
            fontWeight: 500
          }
        }
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(event, checked) => onChange(checked)}
            defaultChecked />}
        label={label} />
    </ThemeProvider>
  );
};

export default TableToolbarCheckbox;